// Auto-generated: keep in sync with package.json version
export const VERSION = "1.3.0";
